import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../../constants/styles';

const {
  FLAT_BUTTON_BG_COLOR,
  FLAT_BUTTON_COLOR,
  DANGER_STATUS_COLOR
} = constants;

let styles = {
  flatButton: {
    backgroundColor: FLAT_BUTTON_BG_COLOR,
    color: FLAT_BUTTON_COLOR,
    ':hover': {
      backgroundColor: 'none'
    }
  },
  idField: {
    display: 'flex',
    width: '100%',
    alignItems: 'center'
  },
  deleteIcon: {
    cursor: 'pointer',
    fontSize: '1.2em',
    color: DANGER_STATUS_COLOR,
    margin: '0 0 10px 15px'
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/forms/addtagform/AddTagForm.styles.js